<template>
  <v-card class="text-left" v-if="!insideDashboard">
    <v-card-title>{{
      insideDashboard
        ? $t("dashboard.changeTitle")
        : $t("dashboard.chooseTitle")
    }}</v-card-title>
    <div v-if="!insideDashboard">
      <v-card-text>
        <v-autocomplete
          autocomplete="off"
          :label="$t('dashboard.name')"
          v-model="dashboardId"
          :items="dashboards"
          item-text="name"
          item-value="dashboardId"
          prepend-icon="mdi-calendar-today"
          required
        />
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" text @click="submit()">
          {{ $t("common.show") }}
        </v-btn>
      </v-card-actions>
    </div>
    <v-container fluid v-else>
      <v-row justify="space-between">
        <v-col sm="12" md="10" lg="10">
          <v-card-text>
            <v-autocomplete
              autocomplete="off"
              :label="$t('dashboard.name')"
              v-model="dashboardId"
              :items="dashboards"
              item-text="name"
              item-value="dashboardId"
              prepend-icon="mdi-calendar-today"
              required
            />
          </v-card-text>
        </v-col>
        <v-col sm="12" md="2" lg="2">
          <v-card-actions>
            <v-btn color="primary" class="mt-6" @click="submit()">
              {{ $t("common.refresh") }}
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "DashboardSelect",
  props: {
    insideDashboard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dashboardId: null,
    };
  },
  computed: {
    ...mapState("dashboards", ["dashboards", "defaultDashboard"]),
  },
  methods: {
    ...mapActions("dashboards", ["setDefault", "getDashboards", "getDefault"]),
    async submit() {
      if (this.dashboardId == null && this.$route.params.id != undefined) {
        this.dashboardId = this.$route.params.id;
      }

      for (let i = 0; i < this.dashboards.length; i++) {
        let e = this.dashboards[i];
        if (e.dashboardId == this.dashboardId) {
          await this.setDefault({ dashboardId: e.dashboardId });
          await this.getDefault();
          this.$router.push(`dashboard/${this.dashboardId}`);
          break;
        }
      }
    },
  },
  async created() {
    await this.getDashboards();
    await this.getDefault();
  },
  watch: {
    //Emit selection-changed event when user selects a valid dashboard in the dropdown
    async dashboardId(newVal) {
      if (newVal !== null) {
        for (let i = 0; i < this.dashboards.length; i++) {
          let e = this.dashboards[i];

          if (e.dashboardId == this.dashboardId) {
            await this.setDefault({ dashboardId: e.dashboardId });
            await this.getDefault();
            this.$router.push(`dashboard/${this.dashboardId}`);
            break;
          }
        }
      }
    },
  },
};
</script>

<style>
</style>